const $ = require('jquery');
const Mustache = require('mustache');
const data = require('header.data');
const analytics = require('header.analytics');

class MainFlyout {
  constructor() {
    this.templates = {};
    this.templates.desktopSection = `
      <div class="MainFlyout__wrapper MainFlyout__wrapper--border">
        <header>
          {{#allLink}}<a href="{{{allLink}}}" class="MainFlyout__header">{{header}}</a>{{/allLink}}
          {{^allLink}}<span class="MainFlyout__header">{{header}}</span>{{/allLink}}
        </header>
        <ul class="MainFlyout__list">
          {{#links}}
            <li class="MainFlyout__item">
              <a href="{{url}}" class="MainFlyout__link"{{#sub}} data-level="{{sub}}"{{/sub}} title="{{name}}"{{#direct}} data-type="direct"{{/direct}}>{{name}}</a>
            </li>
          {{/links}}
          {{#allLink}}
            <li class="MainFlyout__item">
              <a href="{{{allLink}}}" class="MainFlyout__link" title="View All {{name}}" data-type="direct">View All {{name}}</a>
            </li>
          {{/allLink}}
        </ul>
      </div>
      `;

    this.templates.desktopFeature = `
      <div class="MainFlyout__wrapper">
        <span class="MainFlyout__detailsHeader">{{{title}}}</span>
        <a href="{{{link}}}" class="bttn-outline bttn--cta bttn--force-left">
          <span class="bttn__content">{{cta}}</span>
        </a>
      </div>
      `;

    this.templates.level1Flyout = `
      <ul class="MainFlyout__list">
        {{#l1}}
        {{^hideL1}}
        <li class="MainFlyout__item">
          <a href="{{link}}" class="MainFlyout__link{{#activeHolidayClass}} MainFlyout__link--{{activeHolidayClass}}{{/activeHolidayClass}}" data-level="{{name}}" data-image="{{feature.image}}" data-title="{{feature.title}}" data-cta="{{feature.cta}}" data-link="{{feature.link}}" title="{{name}}">{{name}}</a>
        </li>
        {{/hideL1}}
        {{/l1}}
      </ul>
      `;

    this._interactWithLevel1Link = this._interactWithLevel1Link.bind(this);
    this._logLevel2Link = this._logLevel2Link.bind(this);
    this._interactWithLevel2Link = this._interactWithLevel2Link.bind(this);
    this._logMainMenuClick = this._logMainMenuClick.bind(this);
    this._registerHoverIntent = this._registerHoverIntent.bind(this);
    this.init = this.init.bind(this);
  }

  _logEventPath(type, pathArray) {
    // Get header at the beginning, then join them all
    return analytics.logEvent(type, ['header'].concat(pathArray).join('>'));
  }

  _stopTouchHandling(event) {
    if (event.type === 'touchend') {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  _triggerHoverintent() {
    $(this).trigger({
      type: 'hoverintent',
      target: this,
    });
  }

  _setMenuState(state) {
    $('.MainFlyout')
      .toggleClass('MainFlyout--panels-3', state === 'level2')
      .toggleClass('MainFlyout--panels-4', state === 'level3');
  }

  _highlightLink($menu, $item) {
    $('.MainFlyout__link--active', $menu).removeClass(
      'MainFlyout__link--active',
    );
    $item.addClass('MainFlyout__link--active');
  }

  _clearUrl(urlString) {
    // Need to ensure this value isn't just a placeholder
    // if it is, we need to remove the string so Mustache can tell.
    return urlString === '#' ? '' : urlString;
  }

  _interactWithLevel1Link(event) {
    const $this = $(event.target);
    const level1Data = $this.data();
    const level1Name = $this.text();
    const level1Url = $this.attr('href');
    let requestLevel2Data;

    if (event.type !== 'click') {
      requestLevel2Data = data.getLevel2Data(level1Data.level);
      this._stopTouchHandling(event);

      this._highlightLink('.MainFlyout__level1', $this);
      const clearUrl = this._clearUrl;
      requestLevel2Data.then((level2Data) => {
        const htmlContent = Mustache.render(this.templates.desktopSection, {
          header: level1Name,
          links: level2Data,
          allLink: clearUrl(level1Url),
          name: level1Name,
        });

        $('.MainFlyout__level2').html(htmlContent);
        $('.MainFlyout__level1Details')
          .css('background-image', 'url(' + level1Data.image + ')')
          .html(Mustache.render(this.templates.desktopFeature, level1Data));

        this._setMenuState('level2');
      });
    } else {
      this._logEventPath('header click', ['all departments', level1Name]);
    }
  }

  _logLevel2Link(event) {
    const $this = $(event.target);
    const level1Name = $('.MainFlyout__level1 .MainFlyout__link--active').data(
      'level',
    );
    const level2Name = $this.text();

    this._logEventPath('header click', [
      'all departments',
      level1Name,
      level2Name,
    ]);
  }

  _interactWithLevel2Link(event) {
    const $this = $(event.target);
    const level1Name = $('.MainFlyout__level1 .MainFlyout__link--active').data(
      'level',
    );
    const level2Name = $this.text();
    const level2Url = $this.attr('href');
    let requestLevel3Data;

    if (event.type !== 'click') {
      // stop touch handling
      this._stopTouchHandling(event);

      // Update the selected state
      this._highlightLink('.MainFlyout__level2', $this);

      requestLevel3Data = data.getLevel3Data(level1Name, level2Name);

      requestLevel3Data.then((level3Data) => {
        const htmlContent = Mustache.render(this.templates.desktopSection, {
          header: level2Name,
          links: level3Data,
          allLink: this._clearUrl(level2Url),
          name: level2Name,
          direct: true,
        });
        // Update the content
        $('.MainFlyout__level3').html(htmlContent);

        // Open the menu
        this._setMenuState('level3');
      });

      // If it failed - could be that the index doesn't exist, or that its got no results
      requestLevel3Data.catch(() => {
        this._setMenuState('level2');

        if (event.type === 'touchend' && level2Url !== '#') {
          // log the event
          this._logEventPath('header click', [
            'all departments',
            level1Name,
            level2Name,
          ]);

          // Go where we were going any way - have to do this since we prevented the default to wait for ajax
          window.location.assign(level2Url);
        }
      });
      // if its click and the link is dead
    } else if (level2Url === '#') {
      event.preventDefault();
      event.stopPropagation();
    } else {
      this._logEventPath('header click', [
        'all departments',
        level1Name,
        level2Name,
      ]);
    }
  }

  _notifyMenuState(state) {
    // Use a namespaced event, pass along the state
    $(document).trigger('menuState', [
      {
        isOpen: state,
        menu: 'main',
      },
    ]);
  }

  _logMainMenuClick(event) {
    // Find the closest anchor tag
    const $this = $(event.target);
    const level1Name = $('.MainFlyout__level1 .MainFlyout__link--active').data(
      'level',
    );
    const level2Name = $(
      '.MainFlyout__level2 .MainFlyout__link--active',
    ).text();
    const path = ['all departments', level1Name];
    const url = $this.attr('href');

    if (event && event.type === 'touchend') {
      event.preventDefault();
    }

    if (level2Name) {
      path.push(level2Name);
    }

    path.push($this.text());

    this._logEventPath('header click', path);

    if (event.type === 'touchend') {
      // because we prevented the touchend with preventDefault to stop click... it also stops the touchend.
      window.location.assign(url);
    }
  }

  _registerHoverIntent(selector) {
    const triggerHoverintent = this._triggerHoverintent;
    $(document).hoverIntent({
      selector: selector,
      over: triggerHoverintent,
      out: $.noop,
    });
  }

  _renderLevel1Categories() {
    const modifiedTemplate = this.templates.level1Flyout;
    data.getLevel1Data().then(function _renderLevel1Data(level1Data) {
      if (level1Data && !$.isEmptyObject(level1Data)) {
        const htmlContent = Mustache.render(modifiedTemplate, {
          l1: level1Data,
        });
        $('.MainFlyout__level1Wrapper').empty().html(htmlContent);
      }
    });
  }

  init() {
    this._renderLevel1Categories();
    $(document)
      .on(
        'click touchend hoverintent',
        '.MainFlyout__level1 .MainFlyout__link',
        this._interactWithLevel1Link,
      )
      .on(
        'click touchend hoverintent',
        '.MainFlyout__level2 .MainFlyout__link:not([data-type="direct"])',
        this._interactWithLevel2Link,
      )
      .on(
        'click touchend',
        '.MainFlyout__level2 .MainFlyout__link[data-type="direct"]',
        this._logLevel2Link,
      )
      .on(
        'click touchend',
        '.MainFlyout__level1Details a',
        this._logMainMenuClick,
      )
      .on(
        'click touchend',
        '.MainFlyout__level3 .MainFlyout__link',
        this._logMainMenuClick,
      )
      .on(
        'click touchend',
        '.MainFlyout__level2 .MainFlyout__header',
        this._logLevel2Link,
      )
      .on(
        'click touchend',
        '.MainFlyout__level3 .MainFlyout__header',
        this._logMainMenuClick,
      );

    this._registerHoverIntent('.MainFlyout__level1 .MainFlyout__link');
    this._registerHoverIntent('.MainFlyout__level2 .MainFlyout__link');
  }
}

module.exports = new MainFlyout();
